import React, { Component } from 'react'
import { Navbar, Nav } from 'react-bootstrap';
import styles from './Navigation.module.css';
import navbarLogo from '../../../assets/AppName.png';

export default class Navigation extends Component {
    render() {
        return (
            <React.Fragment>
                {/* <Navbar expand="lg">
                    <Navbar.Brand className="app-logo">
                        <div></div><span className='camphire-main-logo-text'></span>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="mr-auto">
                            <span id="username"></span>
                        </Nav>
                    </Navbar.Collapse>
                </Navbar> */}
                <div className={`${styles.navbar_container} d-flex justify-content-between align-center`}>
                    <div className={styles.admin_app_logo}>
                        <img src={navbarLogo} alt='Elmaam Logo' />
                        {/* <span className='camphire-main-logo-text'></span> */}
                    </div>
                    <div className={styles.navbar_option}>
                        <span id="username"></span>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
